import { render, staticRenderFns } from "./arti_list.vue?vue&type=template&id=76f880f1&scoped=true"
import script from "./arti_list.vue?vue&type=script&lang=js"
export * from "./arti_list.vue?vue&type=script&lang=js"
import style0 from "./arti_list.vue?vue&type=style&index=0&id=76f880f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f880f1",
  null
  
)

export default component.exports